import React, { useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { Button, Form, Modal, Spinner, Dropdown, InputGroup, Table } from 'react-bootstrap';
import $ from 'jquery';
import { AppContext } from '../App';

export const Customers = () => {
	const { accessToken, user, setAuthForm, link, customers, setCustomers, getCustomersLoad, postCall, setGetLoad, getLoad, getBill, setViewBillModal } = useContext(AppContext);

	const [newCustomerModel, setNewCustomerModel] = useState(false);
	useEffect(() => {
		if (!newCustomerModel) {
			setSearchResult(prev => { });
			setSelectedItem();
			setEditCus(false);
		}
	}, [newCustomerModel]);
	const [addCustomerLoad, setAddCustomerLoad] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const [selectCount, setSelectCount] = useState(-1);
	const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
	const [selectedItem, setSelectedItem] = useState();
	useEffect(() => {
		if (selectedItem !== undefined) {
			$('#cus_phone').val(selectedItem.profile.phone);
			$('#cus_name').val(selectedItem.profile.name);
			$('#cus_address').val(selectedItem.profile.address);
		} else {
			$('#cus_name').val('');
			$('#cus_address').val('');
		}
	}, [selectedItem]);
	const [editCus, setEditCus] = useState(false);
	const [searchResult, setSearchResult] = useState({});
	const addCustomer = (e) => {
		e.preventDefault();
		let name = e.target.name.value;
		let phone = e.target.phone.value;
		let address = e.target.address.value;
		if (name === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (name !== "" && !editCus) {
			setAddCustomerLoad(true);
			postCall('api/cp/add/customer/', {
				name: name,
				phone: phone,
				address: address,
			}).then((response) => {
				setAddCustomerLoad(false);
				setCustomers(response.data);
				setNewCustomerModel(false);
			}).catch((err) => {
				setAddCustomerLoad(false);
			});
		} else if (name !== "" && editCus) {
			setAddCustomerLoad(true);
			postCall('api/cp/edit/customer/', {
				customer_id: selectedItem.id.substring(1),
				name: name,
				phone: phone,
				address: address,
			}).then((response) => {
				setAddCustomerLoad(false);
				setCustomers(response.data);
				setNewCustomerModel(false);
			}).catch((err) => {
				setAddCustomerLoad(false);
			});
		}
	}
	const searchCustomer = (c_num) => {
		if (editCus !== undefined && !editCus) {
			setSearchResult(prev => { });
			if (c_num !== "") {
				if (customers !== undefined) {
					setSelectedItem();
					if (Object.keys(customers).length > 0) {
						setSelectCount(-1);
						setShowAutoSuggestion(true);
						let count = 0;
						Object.keys(customers).map((customer, custi) => {
							if (customers[customer].phone.match(c_num)) {
								if (count < 20) {
									setSearchResult(prev => ({ ...prev, [customer]: customers[customer] }));
									count += 1;
								}
							}
						});
					}
				}
			} else {
				setSearchResult(prev => { });
			}
		}
	}
	$('#cus_phone').off().on("keydown", function (e) {
		var code = e.which || e.keyCode;
		if (code === 40) {
			e.preventDefault();
			if (selectCount < Object.keys(searchResult).length - 1) {
				setSelectCount(prev => prev + 1);
			} else {
				setSelectCount(0);
			}
		} else if (code === 38) {
			e.preventDefault();
			if (selectCount > 0) {
				setSelectCount(prev => prev - 1);
			} else {
				setSelectCount(Object.keys(searchResult).length - 1);
			}
		} else if (code === 13) {
			e.preventDefault();
			setShowAutoSuggestion(false);
			if (selectCount >= 0) {
				setSelectedItem({ id: Object.keys(searchResult)[selectCount], profile: searchResult[Object.keys(searchResult)[selectCount]] });
			}
		}
	});

	const [customerSearchResults, setCustomerSearchResults] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [searchPageCount, setSearchPageCount] = useState(0);
	const [currentSearchPage, setCurrentSearchPage] = useState(0);

	useEffect(() => {
		if (customerSearchResults !== undefined) {
			setCurrentSearchPage(0);
			let len = customerSearchResults.length;
			setSearchPageCount(Math.ceil(len / 10));
		}
	}, [customerSearchResults]);

	const searchCustomers = (s_name) => {
		if (s_name !== "") {
			if (customers !== undefined && Object.keys(customers).length > 0) {
				const results = [];
				let count = 0;
				for (const customer in customers) {
					if (count >= 800) break;
					if (customers[customer].name.toLowerCase().includes(s_name.toLowerCase()) || customers[customer].phone.includes(s_name)) {
						results.push(customer);
						count += 1;
					}
				}
				setCustomerSearchResults(results);
			} else {
				setCustomerSearchResults(Object.keys(customers));
			}
		} else {
			setCustomerSearchResults(Object.keys(customers));
		}
	}

	useEffect(() => {
		if (customers !== undefined) {
			// Re-run search if there's an active search term
			if (customerSearchResults.length === 0) {
				setCurrentSearchPage(0);
				setCustomerSearchResults(Object.keys(customers));
				setSearchPageCount(Math.ceil(Object.keys(customers).length / 10));
			}
			if (searchTerm !== "") {
				searchCustomers(searchTerm);
			}
		}
	}, [customers]);

	const [cbill, setCbill] = useState();
	const [billModal, setBillModal] = useState(false);
	useEffect(() => {
		if (!billModal) {
			setCbill();
		}
	}, [billModal])
	return (
		<div className='container-fluid'>
			<div className="bgp flex-wrap p-2 justify-content-between align-items-center br-3 mb-3" >
				<span>{getCustomersLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Customers'}</span>
				<div className="flex-wrap align-items-center justify-content-end gap-2" >
					{
						user !== undefined ? (
							user.type === 'admin' ? (
								<Button className="btn-t1" onClick={() => { setNewCustomerModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
							) : (
								user.permission !== undefined ? (
									user.permission.customer !== undefined && user.permission.customer.A ? (
										<Button className="btn-t1" onClick={() => { setNewCustomerModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
									) : ''
								) : ''
							)
						) : ''
					}
				</div>
			</div>
			<div className="d-grid mb-3" >
				<Form onSubmit={(e) => { e.preventDefault() }}>
					<InputGroup>
						<Form.Control
							value={searchTerm}
							onChange={(e) => {
								const value = e.target.value;
								setSearchTerm(value);
								searchCustomers(value);
							}}
							className="br-2"
							size="lg"
							type="text"
							placeholder="Search here"
						/>
						<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
					</InputGroup>
				</Form>
			</div>
			<div className='d-grid' >
				{
					customers !== undefined && Object.keys(customers).length > 0 ? (
						customerSearchResults !== undefined && customerSearchResults.length > 0 ? (
							<>
								{
									customerSearchResults.map((item, ts_i) => (
										searchPageCount !== undefined && ts_i >= currentSearchPage && ts_i < currentSearchPage + 10 ? (
											<div className="d-flex bgs1 br-3 bdr1 mb-3 closed-item p-2 align-items-center justify-content-between" key={`customer_${ts_i}`} >
												<div className="d-grid align-items-center justify-content-start px-2" >
													<div className='flex-wrap align-items-center justify-content-start' >
														<span className="tp1 f16" >{customers[item].name}</span>
														{
															customers[item].phone !== undefined && customers[item].phone !== "" ? (
																<span className="tp2 f14 px-2" >, <i className="bi bi-telephone"></i> {customers[item].phone}</span>
															) : ''
														}
													</div>
													{
														customers[item].address !== undefined && customers[item].address !== "" ? (
															<span className='f12 tp3' ><i className="bi bi-geo-alt"></i> {customers[item].address}</span>
														) : ''
													}
												</div>
												<div className="flex-wrap align-items-center justify-content-end gap-2 py-1" >
													<Dropdown menuRole >
														<Dropdown.Toggle variant="light" size="sm" className="br-4" ><i class="bi bi-three-dots-vertical"></i></Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item onClick={() => {
																setGetLoad(true);
																setBillModal(true);
																postCall('api/cp/get/customer/bills/', { c_id: item.substring(1) }).then(res => {
																	setGetLoad(false);
																	setCbill(res.data);
																}).catch(err => {
																	setGetLoad(false);
																	setBillModal(false);
																})
															}} >
																<div className="drop-menu-item">
																	<i className="bi bi-receipt"></i>
																	<span>Get bills</span>
																</div>
															</Dropdown.Item>
															{
																user !== undefined ? (
																	user.type === 'admin' ? (
																		<Dropdown.Item onClick={() => {
																			setEditCus(true);
																			setSelectedItem({ id: item, profile: customers[item] });
																			setNewCustomerModel(true);
																		}} >
																			<div className="drop-menu-item">
																				<i className="bi bi-pencil-square"></i>
																				<span>Edit</span>
																			</div>
																		</Dropdown.Item>
																	) : (
																		user.permission !== undefined ? (
																			user.permission.customer !== undefined && user.permission.customer.E ? (
																				<Dropdown.Item onClick={() => {
																					setEditCus(true);
																					setSelectedItem({ id: item, profile: customers[item] });
																					setNewCustomerModel(true);
																				}} >
																					<div className="drop-menu-item">
																						<i className="bi bi-pencil-square"></i>
																						<span>Edit</span>
																					</div>
																				</Dropdown.Item>
																			) : ''
																		) : ''
																	)
																) : ''
															}
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</div>
										) : ''
									))
								}
								<div className="py-2 pagination-wrap" >
									{
										searchPageCount > 0 && (
											<>
												{/* First Page Button */}
												<div
													onClick={() => { setCurrentSearchPage(0) }}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-left"></i></span>
												</div>

												{/* Previous 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.max(0, currentPageIndex - 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-left"></i></span>
												</div>

												{/* Page Numbers (Max 6 visible) */}
												{
													(() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const startPage = Math.floor(currentPageIndex / 6) * 6;
														const endPage = Math.min(startPage + 6, searchPageCount);

														return Array.from({ length: endPage - startPage }, (_, i) => {
															const pageIndex = startPage + i;
															return (
																<div
																	key={`search-page-${pageIndex}`}
																	onClick={() => { setCurrentSearchPage(pageIndex * 10) }}
																	className={currentSearchPage === pageIndex * 10 ? 'pageination-index m-2 active' : 'pageination-index m-2'}
																>
																	<span>{pageIndex + 1}</span>
																</div>
															);
														});
													})()
												}

												{/* Next 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.min(searchPageCount - 1, currentPageIndex + 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-right"></i></span>
												</div>

												{/* Last Page Button */}
												<div
													onClick={() => { setCurrentSearchPage((searchPageCount - 1) * 10) }}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-right"></i></span>
												</div>
											</>
										)
									}
								</div>
							</>
						) : (
							<span>Search result not found!</span>
						)
					) : 'Not found'
				}
			</div>
			<Modal size="xl" show={newCustomerModel} backdrop="static" onHide={() => { setNewCustomerModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>{editCus ? 'Update' : 'Add new'} Customer</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addCustomer} >
						<Form.Group className="mb-3">
							<Form.Label>Contact number </Form.Label>
							<div className="serach-customer d-grid pos-rel">
								<Form.Control onBlur={(e) => {
									setTimeout(() => {
										setShowAutoSuggestion(false);
									}, 200);
								}} autoComplete="off" onWheel={(e) => { e.target.blur() }} id="cus_phone" onChange={(e) => { searchCustomer(e.target.value) }} type="number" name="phone" className="shadow-none br-2" placeholder="Contact number" />

								{
									searchResult !== undefined && showAutoSuggestion ? (
										Object.keys(searchResult).length > 0 ? (
											<div className="customer-search-results bdr1">
												{
													Object.keys(searchResult).map((cus, cus_index) => (
														<span onClick={() => { setSelectedItem({ id: cus, profile: searchResult[cus] }) }} className={cus === Object.keys(searchResult)[selectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`cust_${cus_index}`}>{searchResult[cus].name} - {searchResult[cus].phone} </span>
													))
												}
											</div>
										) : ''

									) : ''
								}

							</div>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="text" id="cus_name" name="name" className="shadow-none br-2" placeholder="Customer Name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Address</Form.Label>
							<Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="address" />
						</Form.Group>
						<div className="d-grid">
							{
								addCustomerLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1"><i className="bi bi-floppy2-fill"></i> {editCus ? 'UPDATE' : 'SAVE'}</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
			<Modal size="xl" show={billModal} backdrop="static" onHide={() => { setBillModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>
						{
							getLoad ? (
								<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
							) : (
								cbill !== undefined && cbill.customer_name !== undefined && cbill.customer_phone !== undefined ? (
									<span className="f18" >{`${cbill.customer_name}, ${cbill.customer_phone}`}</span>
								) : 'Not found!'
							)
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{
						cbill !== undefined && cbill.bills !== undefined && Object.keys(cbill.bills).length > 0 ? (
							<Table bordered className="tbl-bg-blue" >
								<thead>
									<tr>
										<th><span className="tp2" >Date</span></th>
										<th><span className="tp2" >Time</span></th>
										<th><span className="tp2" >Invoice</span></th>
										<th className="text-end tp2" ><span>SC</span></th>
										<th className="text-end tp2" ><span>TC</span></th>
										<th className="text-end tp2" ><span>Credit</span></th>
										<th className="text-end tp2" >Total</th>
									</tr>
								</thead>
								<tbody>
									{
										Object.keys(cbill.bills).map((bill, bill_i) => (
											<tr key={`bill_${bill_i}`}>
												<td><span className="tp2">{cbill.bills[bill].bill_date} <span onClick={() => {
													getBill(cbill.bills[bill].bill_id);
													setViewBillModal(true);
												}} className="view-bill-link" ><i className="bi bi-receipt" /> Bill</span></span></td>
												<td><span className="tp2">{cbill.bills[bill].bill_time}</span></td>
												<td><span className="tp2">{cbill.bills[bill].bill_id}</span></td>
												<td className="tp2 text-end"><span>{cbill.bills[bill].service_amount_total}</span></td>
												<td className="tp2 text-end"><span>{cbill.bills[bill].transaction_total}</span></td>
												<td className="tp2 text-end">
													{
														cbill.bills[bill].credit_amount !== null && cbill.bills[bill].credit_amount !== "" && cbill.bills[bill].credit_amount > 0 ? (
															cbill.bills[bill].credit_status ? (
																<span className="sucess-tag mx-2"><i className="bi bi-check-circle"></i> Paid</span>
															) : (

																<span className="error-message mx-2"><i className="bi bi-x-circle"></i> Pending</span>
															)
														) : ''
													}
													<span>{cbill.bills[bill].credit_amount}</span>
												</td>
												<td className="tp2 text-end"><span>{cbill.bills[bill].bill_total}</span></td>
											</tr>
										))
									}
									<tr>
										<td></td>
										<td colSpan={2} className="f16 text-end bgy">Total</td>
										<td className="text-end bgy" ><span>{cbill.serv_bills_total}</span></td>
										<td className="text-end bgy" ><span>{cbill.trans_bills_total}</span></td>
										<td className="text-end bgy" ><span>{cbill.credit_bills_total}</span></td>
										<td className="text-end bgy" ><span>{cbill.bills_total}</span></td>
									</tr>
								</tbody>
							</Table>
						) : 'Not found!'
					}
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</div>
	)
}